/* tslint:disable */
/* eslint-disable */
/**
 * Webmeet service API
 * Service for web meetings management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMeetingResponseDto
 */
export interface CreateMeetingResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateMeetingResponseDto
     */
    id?: string;
    /**
     * Meeting creator user id
     * @type {string}
     * @memberof CreateMeetingResponseDto
     */
    creator?: string;
    /**
     * Meeting title
     * @type {string}
     * @memberof CreateMeetingResponseDto
     */
    title?: string;
    /**
     * Start time of the meeting
     * @type {string}
     * @memberof CreateMeetingResponseDto
     */
    startTime?: string;
    /**
     * End time of the meeting
     * @type {string}
     * @memberof CreateMeetingResponseDto
     */
    endTime?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateMeetingResponseDto
     */
    participants?: Array<string>;
}

/**
 * Check if a given object implements the CreateMeetingResponseDto interface.
 */
export function instanceOfCreateMeetingResponseDto(value: object): boolean {
    return true;
}

export function CreateMeetingResponseDtoFromJSON(json: any): CreateMeetingResponseDto {
    return CreateMeetingResponseDtoFromJSONTyped(json, false);
}

export function CreateMeetingResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMeetingResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'creator': json['creator'] == null ? undefined : json['creator'],
        'title': json['title'] == null ? undefined : json['title'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'participants': json['participants'] == null ? undefined : json['participants'],
    };
}

export function CreateMeetingResponseDtoToJSON(value?: CreateMeetingResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'creator': value['creator'],
        'title': value['title'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'participants': value['participants'],
    };
}

